import { createActionTypes } from "@helpers/redux-helpers";

export const getConversationDetailsActionTypes = createActionTypes(
  "chat/conversations/getById",
);

export const getConversationsActionTypes = createActionTypes(
  "chat/conversations/get",
);

export const getMoreConversationsActionTypes = createActionTypes(
  "chat/conversations/getMore",
);

export const hideConversationActionTypes = createActionTypes(
  "chat/conversations/hide",
);

export const createConversationActionTypes = createActionTypes(
  "chat/conversations/create",
);

export const getMessagesActionTypes = createActionTypes("chat/messages/get");

export const getMoreMessagesActionTypes = createActionTypes(
  "chat/messages/getMore",
);

export const deleteMessageActionTypes = createActionTypes(
  "chat/messages/delete",
);

export const sendMessageActionTypes = createActionTypes("chat/message/send");
export const messageSentActionType = "chat/message/sent";

export const markAsReadActionTypes = createActionTypes(
  "chat/conversation/read",
);

export const leaveChatActionType = "chat/leave";

export const getUnreadCountActionTypes = createActionTypes(
  "chat/conversations/unread/count",
);

export const editMessageActionTypes = createActionTypes("chat/messages/edit");
export const setEditMessageIdActionType = "chat/editMessageId/set";
export const resetEditMessageIdActionType = "chat/editMessageId/reset";

// ws
export const messageReceivedActionTypes = createActionTypes(
  "chat/messages/newMessage",
);
export const messageReceivedUnreadCountActionTypes = createActionTypes(
  "chat/messages/unread/count",
);
export const conversationUpdateActionTypes = createActionTypes(
  "chat/conversations/update",
);
export const addMessageActionTypes = createActionTypes("chat/messages/add");

export const addProposalMessageActionTypes =
  createActionTypes("chat/proposal/add");

export const addConversationActionTypes = createActionTypes(
  "chat/conversation/add",
);

export const removeMessageActionTypes = createActionTypes(
  "chat/messages/remove",
);
export const updateIsMyMessagesReadActionTypes = createActionTypes(
  "chat/conversations/readMine",
);
export const updateConversationActionType = "chat/conversation/update";
export const markMessagesInConversationReadActionType =
  "chat/conversation/ById/MarkRead";
export const messageDeletedActionTypes = createActionTypes(
  "chat/messages/deleted",
);

export const messageEditedActionTypes = createActionTypes(
  "chat/messages/edited",
);

export const newConversationReceivedActionTypes = createActionTypes(
  "chat/conversations/receivedNew",
);

export const addConversationDetailsActionTypes =
  "chat/conversations/addDetails";
